import request from "../utils/request";
import realRequest from "../utils/realRequest";
//获取列表
export function getPageList(params) {
  return request({
    url: `/tag/list?pageNum=${params.currentPage}&pageSize=${
      params.currentPageSize
    }&name=${params.name ? params.name : ""}&key=${
      params.key ? params.key : ""
    }&parentId=${
      params.parentId || params.parentId == 0 ? params.parentId : ""
    }`,
    method: "get"
  });
}
//id查
export function getTagById(params) {
  return request({
    url: `/tag/query?id=${params.id}`,
    method: "get"
  });
}
//删除
export function deleteTagById(params) {
  return request({
    url: `/tag/delete`,
    method: "post",
    data: params
  });
}
//创建tag
export function createTag(params) {
  return request({
    url: `/tag/add`,
    method: "post",
    data: params
  });
}
//修改tag
export function updateTag(params) {
  return request({
    url: `/tag/update`,
    method: "post",
    data: params
  });
}

//获取所有tag
export function getAllTag(params) {
  return request({
    url: `/tag/all?name=${params.name ? params.name : ""}&key=${
      params.key ? params.key : ""
    }&parentId=${
      params.parentId || params.parentId == 0 ? params.parentId : ""
    }`,
    method: "get"
  });
}

//获取树形结构tag
export function nestedAll(params) {
  return request({
    url: `/tag/nestedAll?name=${params}`,
    method: "get"
  });
}

/** 通用资源批量打标 */
export function batchBindResource(data) {
  return request({
    url: `/tag/batchBindResource`,
    method: "post",
    data,
  });
}

/** 批量查询资源已关联 Tag */
export function resourceTagsByKeys(data) {
  return request({
    url: `/tag/resourceTagsByKeys`,
    method: "post",
    data,
  });
}

/** 导出打标专用模板 */
export function exportTagTemplate(params) {
  return realRequest({
    url: `/tag/exportTagTemplate`,
    method: "post",
    data: params,
    responseType: "blob",
  });
}

/** 导出全库 Tag 名录（样式与打标表一致） */
export function exportTagCatalog() {
  return realRequest({
    url: `/tag/exportTagCatalog`,
    method: "get",
    responseType: "blob",
  });
}